module.exports = __webpack_public_path__ + "img/banner.8d9dcb29.png";